import { Fragment } from 'react';
import { Transition, Dialog } from '@headlessui/react';

/**
 * Standard dashboard modal shell (backdrop, centered panel, enter/leave transitions).
 *
 * title        optional Dialog.Title text
 * description  optional node rendered directly under the title
 * maxWidth     Tailwind max-width class for the panel
 * zIndex       Tailwind z-index class for the dialog root
 * clipContent  set false when the modal hosts a DropdownPicker, so its option list isn't clipped
 */
function Modal({
  isOpen,
  onClose,
  title,
  description,
  maxWidth = 'max-w-2xl',
  zIndex = 'z-50',
  clipContent = true,
  children,
}) {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className={`relative ${zIndex}`} onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/30" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel
                className={`w-full ${maxWidth} transform ${clipContent ? 'overflow-hidden' : ''} rounded-2xl bg-white p-6 shadow-xl transition-all`}
              >
                {title && (
                  <div className="mb-4">
                    <Dialog.Title className="text-lg font-medium text-slate-700">{title}</Dialog.Title>
                    {description}
                  </div>
                )}
                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}

export default Modal;
